import Footer from 'components/Footers/Footer'
import Navbar from 'components/Navbars/IndexNavbar';
import React, { useState, useRef, useEffect } from 'react';
import BASE_URL from 'components/BaseUrl/apiConfig';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import backgroundImage from 'assets/img/register_bg_2.png'
import Swal from 'sweetalert2';

const UserRegister = () => {

    const history = useHistory();

    const userNameInputRef = useRef(null);

    const [formData, setFormData] = useState({
        fullname: '',
        organizationName:'',
        username: '',
        email: '',
        password: '',
    });

    const [validationMessages, setValidationErrors] = useState({
        fullname: '',
        organizationName:'',
        username: '',
        email: '',
        password: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
        setValidationErrors((prevErrors) => ({
            ...prevErrors,
            [name]: '', // Clear the validation error when the user types
        }));
    };

    useEffect(() => {
        // Focus on the userName input when the component mounts
        userNameInputRef.current.focus();
    }, []);

    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        // Perform validation logic for each field
        if (formData.fullname.trim() === '') {
            newErrors.fullname = 'Full name is required.';
            isValid = false;
        }

        const usernameRegex = /^[a-z0-9]+$/;// Regex for lowercase letters only
        if (formData.username.trim() === '') {
            newErrors.username = 'Username is required.';
            isValid = false;
        } else if (!usernameRegex.test(formData.username)) {
            newErrors.username = 'Username should only contain lowercase letters without spaces.';
            isValid = false;
        }
        if (formData.organizationName.trim() === '') {
            newErrors.organizationName = 'Organization name is required';
            isValid = false;
        }
        if (formData.email.trim() === '') {
            newErrors.email = 'Email address is required';
            isValid = false;
        }
        else if (!isValidEmail(formData.email)) {
            newErrors.email = 'Email address is not valid.';
            isValid = false;
        }
        if (formData.password.trim() === '') {
            newErrors.password = 'Password is required';
            isValid = false;
        }

        setValidationErrors(newErrors);
        return isValid;
    };

    const isValidEmail = (email) => {
        // Use a regular expression for basic email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(email);
    };


    const handleCreateAccount = async () => {

        // Validate the form before making the API call
        if (!validateForm()) {
            return;
        }
        // If all validations pass, proceed with the API request
        try {
            const response = await fetch(`${BASE_URL}/api/Users/InsertUser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    fullname: formData.fullname,
                    organizationName:formData.organizationName,
                    userName: formData.username,
                    emailId: formData.email,
                    password: formData.password
                }),
            });

            if (response.ok) {
                const data = await response.json();

                setFormData({
                    organizationName:'',
                    fullname: '',
                    username: '',
                    email: '',
                    password: '',
                });

                // Display SweetAlert success message
                Swal.fire({
                    icon: 'success',
                    title: 'Registration successful!',
                    text: 'Please check your email for the verification action.',
                });
                 history.push('/login');
            } else {
                const errorData = await response.json();
                // Handle error scenarios

                Swal.fire({
                    icon: 'error',
                    title: 'Registration failed',
                    text: 'Username or email already exist.',
                });
            }
        } catch (error) {
            console.error('Error creating account:', error.message);
            Swal.fire({
                icon: 'error',
                title: 'Error',
                text: (error.message),
            });
        }
    };



    return (
        <>
            <Navbar />
            <div >
                <div className="container mx-auto px-4 h-full">
                    <div className="flex content-center items-center justify-center h-full">
                        <div className="w-full lg:w-6/12 px-4">
                            <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded-lg bg-white border-0">
                                <div className="rounded-t mb-0 px-3 py-3">
                                    <div className="text-center ">
                                        <h1 className="text-2xl font-bold">
                                            Sign Up
                                        </h1>
                                    </div>
                                    {/* <hr className="mt-3 border-b-1 border-blueGray-300" /> */}
                                </div>
                                <div className="flex-auto px-4 lg:px-10 py-3 pt-0">
                                    <form>
                                        {/* FullName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="fullname"
                                            >
                                                Full Name
                                            </label>
                                            <input
                                                type="text"
                                                id="fullname"
                                                name="fullname"
                                                ref={userNameInputRef}
                                                maxLength={50}
                                                value={formData.fullname}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Full Name"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.fullname}
                                            </div>
                                        </div>
                                        {/* Organization Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="organizationName"
                                            >
                                                Organization Name
                                            </label>
                                            <input
                                                type="text"
                                                id="organizationName"
                                                name="organizationName"
                                               
                                                maxLength={50}
                                                value={formData.organizationName}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Organization Name"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.organizationName}
                                            </div>
                                        </div>
                                        {/* UserName Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="username"
                                            >
                                                Username
                                            </label>
                                            <input
                                                type="text"
                                                id="username"
                                                name="username"
                                                maxLength={30}
                                                value={formData.username}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Username"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.username}
                                            </div>
                                        </div>

                                        {/* Email Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="email"
                                            >
                                                Email
                                            </label>
                                            <input
                                                type="email"
                                                id="email"
                                                name="email"
                                                maxLength={50}
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Email"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.email}
                                            </div>
                                        </div>

                                        {/* Password Input */}
                                        <div className="relative w-full mb-3">
                                            <label
                                                className="block uppercase text-blueGray-600 text-xs font-bold mb-2"
                                                htmlFor="password"
                                            >
                                                Password
                                            </label>
                                            <input
                                                type="password"
                                                id="password"
                                                name="password"
                                                maxLength={40}
                                                value={formData.password}
                                                onChange={handleChange}
                                                className="border rounded w-full"
                                                placeholder="Password"
                                            />
                                            <div className="text-red-500 text-xs mt-1">
                                                {validationMessages.password}
                                            </div>
                                        </div>

                                        {/* Buttons */}
                                        <div className="text-right mt-6 flex flex-row justify-end">
                                            <button type="button" className="bg-lightBlue-500 text-white active:bg-lightBlue-600 text-xs font-bold uppercase px-4 py-2 mr-4 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 ease-linear transition-all duration-150" onClick={() => history.push('/login')}>
                                                Back To Sign in
                                            </button>
                                            <button
                                                className="bg-blueGray-800 text-white active:bg-blueGray-600 text-sm font-bold uppercase px-3 py-2 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1 sm:w-auto ease-linear transition-all duration-150"
                                                type="button"
                                                onClick={handleCreateAccount}
                                            >
                                                Create Account
                                            </button>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}

export default UserRegister
